import { ConcreteEncodable } from "./ConcreteEncodable";

import { XferInfoImplEncoder } from "../../encoder/XferInfoImplEncoder";

import * as CubiqTS from "../../index";
import { XferInfo } from "../XferInfo";

export class XferInfoImpl extends ConcreteEncodable implements XferInfo {
  public static enType: string = "com.bcdfx.model.event.lifecycle.XferInfoImpl";

  /*FID=1*/
  public orderId: CubiqTS.Long | null = null;
  /*FID=2*/
  public rateSource: string;
  /*FID=3*/
  public orderState: CubiqTS.OrderState;
  /*FID=4*/
  public baseCCY: string;
  /*FID=5*/
  public nonBaseCCY: string;
  /*FID=6*/
  public autoFillEligible: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = XferInfoImplEncoder.Instance;
    this.setEncodableType(XferInfoImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "XferInfoImpl[" +
      "orderId=" +
      this.orderId +
      "rateSource=" +
      this.rateSource +
      "orderState=" +
      this.orderState +
      "baseCCY=" +
      this.baseCCY +
      "nonBaseCCY=" +
      this.nonBaseCCY +
      "autoFillEligible=" +
      this.autoFillEligible +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
